import React from 'react'
import PropTypes from 'prop-types'

const MINUTE = 1000 * 60
const SESSION_TIMEOUT = 15 * MINUTE

class SessionTimeout extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool,
    loginUrl: PropTypes.string,
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      setTimeout(() => {
        location.href = this.props.loginUrl
      }, SESSION_TIMEOUT)
    }
  }

  render() {
    return null
  }
}

export default SessionTimeout
